export async function FetchData(url) {
    return await fetch(url);
} 

export async function FetchPost(url, body) {
    return await fetch(url, {
        method: "POST",
        headers:{
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    });
}

export async function FetchPut(url, body) {
    return await fetch(url, {
        method: "PUT",
        headers:{
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    });
}




// WEBPACK FOOTER //
// ./src/api/Fetch.js